/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  combineCodec,
  getEnumDecoder,
  getEnumEncoder,
  type FixedSizeCodec,
  type FixedSizeDecoder,
  type FixedSizeEncoder,
} from "@solana/kit";

/** Verification relationship types */
export enum VerificationRelationship {
  Authentication,
  AssertionMethod,
  KeyAgreement,
  CapabilityInvocation,
  CapabilityDelegation,
}

export type VerificationRelationshipArgs = VerificationRelationship;

export function getVerificationRelationshipEncoder(): FixedSizeEncoder<VerificationRelationshipArgs> {
  return getEnumEncoder(VerificationRelationship);
}

export function getVerificationRelationshipDecoder(): FixedSizeDecoder<VerificationRelationship> {
  return getEnumDecoder(VerificationRelationship);
}

export function getVerificationRelationshipCodec(): FixedSizeCodec<
  VerificationRelationshipArgs,
  VerificationRelationship
> {
  return combineCodec(
    getVerificationRelationshipEncoder(),
    getVerificationRelationshipDecoder(),
  );
}
